import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { CorePreference } from '../../../models/core-preferences/core-preferences.model';
import { CorePreferenceSerializer } from '../../../models/core-preferences/core-preferences-serializer.class';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class CorePreferencesService extends BaseApiService<CorePreference> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "corepreferences", 
        new CorePreferenceSerializer(), 
        new CustomErrorHandlerService());
    }


    searchForPages(businessUnit: string ): Observable<CorePreference[]> {
        return this.httpClient
            .get(`${this.url}/corepreferences/search/forpages`, {
                params: { businessUnit }
            })
            .pipe(map((data: any) => data));
    }

}
